import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { faQuoteLeft } from '@fortawesome/pro-solid-svg-icons/faQuoteLeft'
import { faQuoteRight } from '@fortawesome/pro-solid-svg-icons/faQuoteRight'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'

export const ReviewBox = ({
  date,
  ratingValue,
  reviewText,
  subtitle,
  title = 'Patient Review',
}: {
  date?: string
  ratingValue: number | null
  reviewText: string | null
  subtitle?: string
  title?: string
}) => {
  return (
    <div className='rounded-xl border-2 border-neutral100 p-4 text-neutral600'>
      <div className='flex justify-between'>
        <div className='flex items-baseline'>
          <Icon className='mr-1 text-blue500' icon={faStar} />
          <Text
            className='mr-2 inline text-blue500'
            styleName='p'
            value={ratingValue}
          />
          <Text className='inline' styleName='p-small' value={title} />
        </div>
        <Text styleName='p-small' value={date} />
      </div>
      <Text
        className='mt-4 text-blue400'
        styleName='p-small'
        value={subtitle}
      />

      {reviewText && (
        <div className='mt-2'>
          <Icon className='align-top text-xs' icon={faQuoteLeft} /> {reviewText}
          <Icon className='align-top text-xs' icon={faQuoteRight} />
        </div>
      )}
    </div>
  )
}
